import { createApi } from '@reduxjs/toolkit/query/react';

import { CompanyNewsResponse, ImportantLinksApiResponse } from '@/types/Dashboard';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const dashboardStrapiApi = createApi({
  reducerPath: 'dashboardStrapiApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ useStrapiServer: true, basePath: '', cache: 'no-store' }),
  tagTypes: ['ImportantLink', 'CompanyNews'],
  endpoints: builder => ({
    getImportantLinks: builder.query<ImportantLinksApiResponse, void>({
      query: () => ({
        url: `/pawtree/information-links`,
        next: { tags: ['ImportantLink'] },
      }),
      providesTags: ['ImportantLink'],
      transformResponse(baseQueryReturnValue: ImportantLinksApiResponse, meta, arg) {
        return baseQueryReturnValue;
      },
    }),
    getCompanyNews: builder.query<CompanyNewsResponse, void>({
      query: () => ({
        url: `/pawtree/company-news`,
        next: { tags: ['CompanyNews'] },
      }),
      providesTags: ['CompanyNews'],
      transformResponse(baseQueryReturnValue: CompanyNewsResponse, meta, arg) {
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const { useGetImportantLinksQuery, useGetCompanyNewsQuery } = dashboardStrapiApi;
